import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import landingPageReducer from './slices/landingPageSlice';
import globalLoadingReducer from './slices/globalLoadingSlice';
import careersReducer from './slices/careersSlice';

// Combine all reducers
const rootReducer = combineReducers({
  landingPage: landingPageReducer,
  globalLoading: globalLoadingReducer,
  careers: careersReducer,
});

// Persist configuration
const persistConfig = {
  key: 'root', // Key for the persisted state
  storage,
  whitelist: ['landingPage'], // Only persist auth and settings slices
};

// Wrap the rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
